module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/frame-04c67c1faf5ae5fdbfe82ac35bc370d3.png";